module.exports = __webpack_public_path__ + "static/img/8.4c05680.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/sp/8.png
// module id = SUmC
// module chunks = 0